// extracted by mini-css-extract-plugin
export default {"Head":"review_Head__mE1kp","Heading":"review_Heading__TNFN-","P":"review_P__+F09L","Reviews":"review_Reviews__snziF","Spl":"review_Spl__tPjbj","IMG":"review_IMG__Io5so"};